import Parse from 'parse'
import router from '@/router'
import moment from 'moment'

const state = {
  user: null,
  toastData: {},
  userTypeHeader1: '',
  userObj: null,
  instructorProfile: null,
  instructorListProfile: null,
  studentProfile: null,
  instructorSchoolList: null,
  instructorPackage: null,
  schoolListProfile: null,
  isLogged: false,
  resetPassword: null,
  profileNotCompleted: false,
  sms: false
}

const getters = {
  user: (state) => state.user,
  userTypeHeader1: (state) => state.userTypeHeader1,
  toastData: (state) => state.toastData,
  userObj: (state) => state.userObj,
  instructorProfile: (state) => state.instructorProfile,
  instructorListProfile: (state) => state.instructorListProfile,
  studentProfile: (state) => state.studentProfile,
  instructorSchoolList: (state) => state.instructorSchoolList,
  instructorPackage: (state) => state.instructorPackage,
  schoolListProfile: (state) => state.schoolListProfile,
  isLogged: (state) => state.isLogged,
  resetPassword: (state) => state.resetPassword,
  profileNotCompleted: (state) => state.profileNotCompleted,
  sms: (state) => state.sms
}

const actions = {
  showToast ({ commit }, payload) {
    commit('setToastData', payload)
  },
  setUserTypeHeader ({ commit }, payload) {
    commit('setUserTypeHeaderMutations', payload)
  },
  async getUser ({ commit }) {
    const user = Parse.User.current()
    if (user) {
      /**
       * Unpaid student with a package must never keep a session (same rule
       * LoginForm enforces on manual login). Covers reloading mid-signup:
       * the account exists since the OTP step, but until payment is done
       * they are not allowed into the dashboard.
       */
      if (!user.get('pre_paid') && user.get('packageId')) {
        localStorage.clear()
        Parse.User.logOut()
        commit('setUser', null)
        commit('setUserObj', null)
        commit('setIsLogged', false)
        return
      }
      commit('setIsLogged', true)
      commit('setUser', user)
      commit('setProfileNotCompleted', !!user.get('profileNotCompleted'))
      commit('setUserObj', {
        firstName: user.get('firstName'),
        lastName: user.get('lastName'),
        username: user.get('username'),
        customEmail: user.get('customEmail'),
        email: user.get('email'),
        phone: user.get('phone'),
        dob: user.get('dob'),
        addressOne: user.get('addressOne'),
        addressTwo: user.get('addressTwo'),
        city: user.get('city'),
        province: user.get('province'),
        postalCode: user.get('postalCode'),
        country: user.get('country'),
        profilePicture:
          user.get('profilePicture') !== 'undefined'
            ? user.get('profilePicture')
            : 'https://thedriverx.com/assets/images/user.png',
        licenceNumber: user.get('licenceNumber'),
        uploadLicence: user.get('uploadLicence'),
        location: user.get('location'),
        carPlateNumber: user.get('carPlateNumber'),
        instructorCities: user.get('instructorCities'),
        noSchool: user.get('noSchool'),
        instructingPlateNumber: user.get('instructingPlateNumber')
      })
    } else {
      commit('setUser', null)
      commit('setUserObj', null)
      commit('setIsLogged', false)
    }
  },

  /** Get instructor profile */
  async getInstructorProfile ({ commit }, payload) {
    const UserClass = Parse.Object.extend('User')
    const query = new Parse.Query(UserClass)
    query.equalTo('objectId', payload.instructorId)
    try {
      const response = await query.first()
      /** Get the school name of the instructor */
      const InstructorSchools = Parse.Object.extend('InstructorSchools')
      const isQuery = new Parse.Query(InstructorSchools)

      const User = Parse.Object.extend('User')
      const UserPointerId = new User()
      UserPointerId.id = payload.instructorId
      isQuery.equalTo('instructorId', UserPointerId)
      isQuery.include('schoolId')
      await isQuery
        .first()
        .then((school) => {
          if (
            typeof school.get('schoolId') !== 'undefined' &&
            school.get('schoolId').get('name') !== ''
          ) {
            response.set('schoolName', school.get('schoolId').get('name'))
          }
          commit('setInstructorProfile', response)
        })
        .catch(function (e) {
          /** If no school found, then we still want users object to go ahead */
          commit('setInstructorProfile', response)
          console.log(e)
        })
    } catch (error) {
      console.log(error)
    }
  },

  async getStudentProfile ({ commit }, payload) {
    const UserClass = Parse.Object.extend('User')
    const query = new Parse.Query(UserClass)
    query.equalTo('objectId', payload.studentId)
    try {
      const response = await query.first()
      commit('setStudentProfile', response)
    } catch (error) {
      commit('setStudentProfile', false)
      console.log(error)
    }
  },

  /** Get driving instructors list */
  async getInstructorListProfile ({ commit }, payload) {
    const UserClass = Parse.Object.extend('User')
    const query = new Parse.Query(UserClass)
    query.exists('stripeUserAccountId')
    query.containedIn('instructorCities', [payload.cityName.toLowerCase()])
    query.equalTo('status', true)
    query.equalTo('packageAdded', true)
    // query.equalTo('stripeSubscriptionActive', true)
    query.limit(15)
    await query
      .find()
      .then(function (instructors) {
        console.log(instructors.length)
        commit('setInstructorListProfile', instructors)
      })
      .catch(function (error) {
        commit('setInstructorListProfile', error)
      })
  },

  async getInstructorsSchool ({ commit }, payload) {
    for (var i = 0; i < payload.length; i++) {
      payload[i].set('cities', payload[i].get('instructorCities').join())
      /** Get the school name of the instructor */
      const InstructorSchools = Parse.Object.extend('InstructorSchools')
      const isQuery = new Parse.Query(InstructorSchools)
      const User = Parse.Object.extend('User')
      const UserPointerId = new User()
      UserPointerId.id = payload[i].id
      isQuery.equalTo('instructorId', UserPointerId)
      isQuery.include('schoolId')
      await isQuery
        .first()
        .then((school) => {
          if (
            typeof school !== 'undefined' &&
            school.get('schoolId').get('name') !== ''
          ) {
            payload[i].set('schoolName', school.get('schoolId').get('name'))
          } else {
            payload[i].set('schoolName', '')
          }
        })
        .catch(function (e) {
          console.log(e)
          /** If no school found, then we still want users object to go ahead */
          payload[i].set('schoolName', '')
        })
      if (payload.length === i + 1) {
        commit('setInstructorSchoolList', payload)
      }
    }
  },
  async getInstructorsPackage ({ commit }, payload) {
    // @todo: this set is saving/adding extra fields on user table. this needs to be fixed
    for (var i = 0; i < payload.length; i++) {
      /** Get the hr rate */
      const InstructorPackages = Parse.Object.extend('InstructorPackages')
      const ipQuery = new Parse.Query(InstructorPackages)
      const User = Parse.Object.extend('User')
      const UserPointerId = new User()
      UserPointerId.id = payload[i].id
      ipQuery.equalTo('instructorId', UserPointerId)
      ipQuery.include('schoolId')
      await ipQuery
        .first()
        .then((iPackage) => {
          if (iPackage) {
            payload[i].set('instructorPackageId', iPackage.id)
            payload[i].set(
              'booking_lesson',
              iPackage.get('school_rate')
                ? iPackage.get('school_rate')
                : iPackage.get('booking_lesson')
            )
            payload[i].set('school_rate', iPackage.get('school_rate'))
            payload[i].set(
              'roadtest_rent_car',
              iPackage.get('roadtest_rent_car')
            )
            payload[i].set(
              'rentcar_n_lesson',
              iPackage.get('rentcar_n_lesson')
            )
          }
        })
        .catch(function (e) {
          console.log(e)
          /** If no school found, then we still want users object to go ahead */
          payload[i].set('booking_lesson', 0)
          payload[i].set('roadtest_rent_car', 0)
          payload[i].set('rentcar_n_lesson', 0)
        })
      if (payload.length === i + 1) {
        commit('setInstructorPackage', payload)
      }
    }
  },
  /** Get school package list */
  async getSchoolListProfile ({ commit }, payload) {
    const schoolIds = []
    const SchoolsClass = Parse.Object.extend('Schools')
    const query = new Parse.Query(SchoolsClass)
    query.equalTo('approvedByAdmin', 'Approved')
    query.matches('city', '.*' + payload.cityName + '.*')
    query.include('associatedId')

    const User = Parse.Object.extend('User')
    let innerQuery = new Parse.Query(User)
    // innerQuery.exists("stripeUserAccountId");
    innerQuery.equalTo('status', true)

    const stripeQuery = new Parse.Query('User')
    stripeQuery.equalTo('stripeSubscriptionActive', true)

    const perQuery = new Parse.Query('User')
    perQuery.equalTo('schoolSubscriptionType', 'percentage')

    innerQuery = Parse.Query.or(stripeQuery, perQuery)

    query.matchesQuery('associatedId', innerQuery)
    query.limit(15)

    await query
      .find()
      .then((response) => {
        console.log(response.length)
        if (response.length) {
          Object.keys(response).forEach((key) => {
            if (response[key]) {
              if (
                (typeof response[key]
                  .get('associatedId')
                  .get('stripeSubscriptionActive') !== 'undefined' &&
                  response[key]
                    .get('associatedId')
                    .get('stripeSubscriptionActive')) ||
                response[key]
                  .get('associatedId')
                  .get('schoolSubscriptionType') === 'percentage'
              ) {
                schoolIds.push(response[key].id)
              } else if (response[key].get('associatedId').get('trial')) {
                /** Check if the trial is expired or not */
                const trialEndDate = moment(
                  response[key].get('associatedId').get('trialBegun'),
                  'DD-MM-YYYY'
                ).add(60, 'days')
                const todaysdate = moment()
                var daysToGo = trialEndDate.diff(todaysdate, 'days')
                if (daysToGo > 0) {
                  schoolIds.push(response[key].id)
                }
              }
            }
          })
        }
        return schoolIds
      })
      .then(function (schools) {
        if (schools.length) {
          /** We have found the schools, let's look for their package now */
          const SchoolPackagesClass = Parse.Object.extend('SchoolPackages')
          const query = new Parse.Query(SchoolPackagesClass)
          query.containedIn('schoolId', schools)
          query.include('schoolId')
          query.limit(15)
          const response = query.find()
          return response
        } else {
          return schools
        }
      })
      .then(function (finalResult) {
        console.log(finalResult)
        commit('setSchoolListProfile', finalResult)
      })
      .catch(function (error) {
        commit('setSchoolListProfile', error)
        console.log(JSON.stringify(error))
      })
  },

  async getDriverxPackageByCity ({ commit }, payload) {
    const UserClass = Parse.Object.extend('User')
    const query = new Parse.Query(UserClass)
    query.exists('stripeUserAccountId')
    query.containedIn('instructorCities', [payload.cityName.toLowerCase()])
    query.equalTo('status', true)
    query.equalTo('packageAdded', true)
    await query
      .first()
      .then(async (instructors) => {
        if (instructors) {
          const SchoolPackagesClass = Parse.Object.extend('SchoolPackages')
          const query = new Parse.Query(SchoolPackagesClass)
          /** @todo add driverx packageId here */
          query.containedIn('schoolId', ['SH8HBVt2pk'])
          query.include('schoolId')
          // query.limit(1);
          const response = query.find()
          return response
        } else {
          commit('setSchoolListProfile', [])
        }
      })
      .then(function (finalResult) {
        console.log(finalResult)
        commit('setSchoolListProfile', finalResult)
      })
      .catch(function (error) {
        commit('setSchoolListProfile', error)
      })
  },

  async updateUser ({ commit }, payload) {
    const user = Parse.User.current()
    Object.keys(payload).forEach((key) => {
      if (typeof payload[key] !== 'undefined') {
        user.set(key, payload[key])
      }
    })
    try {
      await user.save(null, { useMasterKey: true }).then(
        async () => {
          const user = Parse.User.current()
          if (
            typeof user.get('uploadLicence') !== 'undefined' &&
            typeof user.get('firstName') !== 'undefined' &&
            typeof user.get('addressOne') !== 'undefined' &&
            user.get('profileNotCompleted')
          ) {
            user.set('profileNotCompleted', false)
            await user.save()
            commit('setProfileNotCompleted', false)
          }
          commit('setUser', user)
          return { status: true, title: 'Success' }
        },
        (error) => {
          console.log(error)
          return { status: true, title: 'Error', message: error.message }
        }
      )
    } catch (error) {
      return { status: true, title: 'Error', message: error.message }
    }
  },

  /** Get driving instructors list */
  async getResetPassword ({ commit }, payload) {
    try {
      await Parse.User.requestPasswordReset(payload.email)
        .then(() => {
          commit('setResetPassword', true)
        })
        .catch((error) => {
          console.log(error)
          commit('setResetPassword', false)
        })
    } catch (error) {
      console.log(error)
      commit('setResetPassword', false)
    }
  },

  /** Send text to the DX */
  async sendSMS ({ commit }, payload) {
    try {
      Parse.Cloud.run('sendSMS', {
        message: payload.message
      })
        .then((res) => {
          console.log(res)
        })
        .catch((error) => {
          console.log(error)
        })
      commit('setSMS', true)
    } catch (error) {
      console.log(error)
      commit('setSMS', false)
    }
  },

  logout ({ commit }) {
    Parse.User.logOut()
    localStorage.clear()
    commit('setUser', null)
    commit('setUserObj', null)
    commit('setIsLogged', false)
    router.push({ name: 'Login' })
  }
}

const mutations = {
  setToastData: (state, data) => {
    console.log(data, 'dataa ssss')
    state.toastData = data
  },
  setUser: (state, user) => (state.user = user),
  setInstructorProfile: (state, instructorProfile) =>
    (state.instructorProfile = instructorProfile),
  setStudentProfile: (state, studentProfile) =>
    (state.studentProfile = studentProfile),
  setInstructorListProfile: (state, instructorListProfile) =>
    (state.instructorListProfile = instructorListProfile),
  setInstructorSchoolList: (state, instructorSchoolList) =>
    (state.instructorSchoolList = instructorSchoolList),
  setInstructorPackage: (state, instructorPackage) =>
    (state.instructorPackage = instructorPackage),
  setSchoolListProfile: (state, schoolListProfile) =>
    (state.schoolListProfile = schoolListProfile),
  setUserObj: (state, userObj) => (state.userObj = userObj),
  setIsLogged: (state, status) => (state.isLogged = status),
  setResetPassword: (state, resetPassword) =>
    (state.resetPassword = resetPassword),
  setUserTypeHeaderMutations: (state, userType) => (state.userTypeHeader1 = userType),
  setProfileNotCompleted: (state, profileNotCompleted) =>
    (state.profileNotCompleted = profileNotCompleted),
  setSMS: (state, sms) =>
    (state.sms = sms)
}

export default {
  state,
  getters,
  actions,
  mutations
}
